import { createServerColumnHelper } from '../shared-compat/DataTable/hooks';
import type { ActiveAlertRow } from '../menu-modal/MenuModal/portal-active-alert-context';
import { parseDateTime } from '../../util';

const helper = createServerColumnHelper<ActiveAlertRow>();
const ch = helper.accessor;

export const alertColumnsDef = () => [
  ch('AlertDescription', 'string', {
    header: 'Alert Description',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('AlertResponse', 'string', {
    header: 'Alert Response',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('AlertStatus', 'string', {
    header: 'Alert Status',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('Company', 'string', {
    header: 'Company',
    cell: (info) => info.getValue(),
    enableColumnFilter: true
  }),
  ch('Site', 'string', {
    header: 'Site',
    cell: (info) => info.getValue(),
    enableColumnFilter: true
  }),

  ch('Asset', 'string', {
    header: 'System/Asset',
    cell: (info) => {
      if (info.row.original.System) {
        return info.row.original.System;
      } else {
        return info.getValue();
      }
    },
    enableColumnFilter: true
  }),
  ch('InstallationName', 'string', {
    header: 'Installation Name',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('Model', 'string', {
    header: 'Model',
    cell: (info) => info.getValue(),
    enableColumnFilter: true
  }),
  ch('SN', 'string', {
    header: 'SN',
    cell: (info) => info.getValue(),
    enableColumnFilter: true
  }),
  ch('Alert', 'string', {
    header: 'Alert',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('Alert', 'string', {
    header: 'Alert',
    cell: (info) => info.getValue(),
    enableColumnFilter: true
  }),
  ch('Start', 'string', {
    header: 'Start',
    cell: (info) => parseDateTime(info.getValue(), true).toLocaleString(),
    enableColumnFilter: true
  }),
  ch('Severity', 'number', {
    header: 'Severity',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('Subject', 'string', {
    header: 'Subject',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('System', 'string', {
    header: 'System',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  }),
  ch('Color', 'string', {
    header: 'Color',
    cell: (info) => info.getValue(),
    enableColumnFilter: true,
    meta: {
      isVisible: false
    }
  })
];
